import React, { useCallback, useEffect, useState } from "react";
import { useWebsocket } from "../../functions/websocket";
import { format, fromUnixTime } from "date-fns";

let downstreamBuffer = [];
let upstreamBuffer = [];
let downstreamPacketsBuffer = [];
let upstreamPacketsBuffer = [];
let macDataBuffer = [];
let statsBufferTimeout = null;
let lastDataObj = null;

let rpDataInitalState = {
  isInitialState: true,
  ArpRequests: 0,
  ArpReplies: 0,
  ArpIgnore: 0,
  ArpErrors: 0,
  DhcpRequests: 0,
  DhcpReplies: 0,
  DhcpErrors: 0,
  DhcpNak: 0,
  ArpPingDowntime: 0,
  ArpPingReplies: 0,
  ArpPingRequests: 0,
  ArpPingUptime: 0,
  DnCount: 0,
  UpCount: 0,
  UpDnLastStateChange: 0,
  Macs: [],
};
/*
 * {
 *  "Ts":1729697953,
 *  "RxPackets":687991772,
 *  "TxPackets":832280085,
 *  "RxBytes":554406935655,
 *  "TxBytes":817981223291,
 *  "ArpRequests":1,
 *  "ArpReplies":1,
 *  "ArpIgnore":0,
 *  "ArpErrors":0,
 *  "ArpPingRequests":45848,
 *  "ArpPingReplies":45844,
 *  "DhcpRequests":0,
 *  "DhcpReplies":0,
 *  "DhcpNak":0,
 *  "DhcpErrors":0,
 *  "ArpPingUptime":1376540,
 *  "ArpPingDowntime":120,
 *  "UpDnLastStateChange":1729650159,
 *  "UpCount":1,
 *  "DnCount":0,
 *  "Macs":[{"mac_address":"ec:a8:6b:f8:bb:49","last_use":1728321380,"use_count":1}]
 *  }

 */
export function useInterfaceStats(
  url,
  httpGetParameters = {
    history: 300,
  },
) {
  const [stats, setStats] = useState({
    downStreamData: [],
    upStreamData: [],
    downStreamPackets: [],
    upStreamPackets: [],
    ...rpDataInitalState,
  });

  useEffect(() => {
    downstreamBuffer = [];
    upstreamBuffer = [];
    downstreamPacketsBuffer = [];
    upstreamPacketsBuffer = [];
    lastDataObj = null;
    statsBufferTimeout = null;
  }, [url]);

  const onStatsMessage = useCallback(
    data => {
      if (statsBufferTimeout) {
        clearTimeout(statsBufferTimeout);
      }

      const dataJson = JSON.parse(data);

      if (lastDataObj != null) {
        const ts = format(
          new Date(fromUnixTime(dataJson.Ts)),
          "yyyy-MM-dd HH:mm:ss",
        );
        const downStreamDiff = dataJson.TxBytes - lastDataObj.TxBytes;
        const upStreamDiff = dataJson.RxBytes - lastDataObj.RxBytes;
        const downStreamPacketsDiff =
          dataJson.TxPackets - lastDataObj.TxPackets;
        const upStreamPacketsDiff = dataJson.RxPackets - lastDataObj.RxPackets;

        downstreamBuffer.push({
          y: downStreamDiff,
          x: ts,
        });

        upstreamBuffer.push({
          y: upStreamDiff,
          x: ts,
        });

        downstreamPacketsBuffer.push({
          y: downStreamPacketsDiff,
          x: ts,
        });

        upstreamPacketsBuffer.push({
          y: upStreamPacketsDiff,
          x: ts,
        });

        statsBufferTimeout = setTimeout(() => {
          let newDownStreamData = [
            ...stats.downStreamData,
            ...downstreamBuffer,
          ];
          let newUpStreamData = [...stats.upStreamData, ...upstreamBuffer];

          let newDownStreamPackets = [
            ...stats.downStreamPackets,
            ...downstreamPacketsBuffer,
          ];
          let newUpStreamPackets = [
            ...stats.upStreamPackets,
            ...upstreamPacketsBuffer,
          ];

          while (newDownStreamData.length > 300) {
            newDownStreamData = newDownStreamData.slice(1);
          }
          while (newUpStreamData.length > 300) {
            newUpStreamData = newUpStreamData.slice(1);
          }
          while (newDownStreamPackets.length > 300) {
            newDownStreamPackets = newDownStreamPackets.slice(1);
          }
          while (newUpStreamPackets.length > 300) {
            newUpStreamPackets = newUpStreamPackets.slice(1);
          }

          setStats({
            downStreamData: newDownStreamData,
            upStreamData: newUpStreamData,
            downStreamPackets: newDownStreamPackets,
            upStreamPackets: newUpStreamPackets,
            ...dataJson,
            Macs: dataJson.Macs || stats.Macs,
          });

          upstreamBuffer = [];
          downstreamBuffer = [];
          downstreamPacketsBuffer = [];
          upstreamPacketsBuffer = [];
        }, 100);
      }

      lastDataObj = dataJson;
    },
    [stats],
  );

  const wsError = useWebsocket(url, onStatsMessage, httpGetParameters);

  return [wsError, stats];
}

let debugBufferTimeout = null;
let debugBuffer = [];

export function useInterfaceDebug(url) {
  const [debug, setDebug] = useState([]);

  useEffect(() => {
    debugBuffer = [];
    debugBufferTimeout = null;
  }, [url]);

  const onDebugMessage = useCallback(
    data => {
      if (debugBufferTimeout) {
        clearTimeout(debugBufferTimeout);
      }

      debugBuffer.push(data);

      debugBufferTimeout = setTimeout(() => {
        setDebug([...debug, ...debugBuffer]);

        debugBuffer = [];
      }, 100);
    },
    [debug],
  );

  const wsError = useWebsocket(url, onDebugMessage);

  return [wsError, debug];
}

export default {};
